
import { AuthTokenRepository } from 'core/repositories/AuthTokenRepository';
import { createDependency } from './createDependency';

export const [useAuthTokenRepository, withAuthTokenRepository] = createDependency<AuthTokenRepository>();
